module.exports = __webpack_public_path__ + "static/media/FolderEmpty.631a0194.png";